"use client";
import {
  useGroup
} from "./CWDOOAGR.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./5M6RSQEC.js";
import {
  __objRest
} from "./4R3V3JGP.js";

// src/composite/composite-group.ts
var TagName = "div";
var useCompositeGroup = createHook(
  function useCompositeGroup2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroup(props);
    return props;
  }
);
var CompositeGroup = forwardRef(function CompositeGroup2(props) {
  const htmlProps = useCompositeGroup(props);
  return createElement(TagName, htmlProps);
});

export {
  useCompositeGroup,
  CompositeGroup
};
